module.exports = __webpack_public_path__ + "img/mi-info.2226ccec.svg";